import MultipleValuesSelector from './MultipleValuesSelector';

const CohortSelector = ({ field, getValues, ...args }) => {
  const values = getValues(field);
  return MultipleValuesSelector({ ...args, values });
};

export default CohortSelector;
